// eslint-disable-next-line
export default new (class GalleryModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.date = data.publishedAt || "";
    model.slug = data.Slug || "";

    if (data.images) {
      model.image = data.images;
    } else {
      model.image = [];
    }

    model.title = data.title || [];
    model.content = data.detail || [];
    model.tag = data.tag || [];
    model.publisher = data.publisher || [];

    return model;
  }
})();
